"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolygonMaskType = void 0;
const Enums_1 = require("../Plugins/PolygonMask/Enums");
Object.defineProperty(exports, "PolygonMaskType", { enumerable: true, get: function () { return Enums_1.Type; } });
